module.exports = __webpack_public_path__ + "img/Trial.3ff8f936.jpg";